export default {
  filters: {
    numberChange: (val) => {
      if (typeof val !== "number") {
        number = 0;
      }
      let number = Number(val);
      if (number >= 10000) {
        number = (Math.floor(number / 1000) / 10).toFixed(1) + "万";
      }
      return number;
    },
  },
};
